import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listVIPConfigs, updateVIPConfig } from './api';
import { VIPConfigInput } from './types';

const key = ['vip-configs'] as const;

export function useVIPConfigs() {
  return useQuery({ queryKey: key, queryFn: listVIPConfigs });
}

export function useUpdateVIPConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ level, input }: { level: number; input: VIPConfigInput }) => updateVIPConfig(level, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: key }),
  });
}
